import styled from "styled-components";

export const GoBackButton = styled.button`
  color: var(--white-secondary);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 19px;
  font-weight: 700;
  background-color: #1b1b1b;
  border-radius: 12px;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: #222222;
    }
  }
`;

export const IconArrowLeftSvg = styled.svg`
  path {
    fill: var(--white-secondary);
  }
`;
